import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class SupportCreateGrievanceListService {

  constructor(public httpClient: HttpClient) { }

  //search lottery user
  async searchGrievanceByPhoneorEmail(data: any) {
    // const formData = new FormData();
    // formData.append("grievanceRequestDtoString", JSON.stringify(data));
    // const url = (await grievanceServerUrl) + "listOfRegUser";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.listOfRegUser, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //
}
